import type { CreateUserTrackingCookieProps } from "./createUserTrackingCookieValue.d";

import { GCLID_SOURCE, GCLID_MEDIUM } from "../../config";

const encodeCookie = (cookieValue: CreateUserTrackingCookieProps) =>
  Buffer.from(JSON.stringify(cookieValue)).toString("base64");

const createUserTrackingCookieValue = (
  gclid: CreateUserTrackingCookieProps["gclid"],
  source: CreateUserTrackingCookieProps["source"],
  medium: CreateUserTrackingCookieProps["medium"]
) => {
  if (gclid) return encodeCookie({ source: GCLID_SOURCE, medium: GCLID_MEDIUM });

  if (source && medium) return encodeCookie({ source, medium });

  return "";
};

export default createUserTrackingCookieValue;
